import i18n from "i18n";

export const namespaceMessages = {
  create: i18n.t('notifications.namespace.create'),
  update: i18n.t('notifications.namespace.update'),
  delete: i18n.t('notifications.namespace.delete')
};
